import React from 'react';
import { GuitarCrossMark } from './Logo';
export function Footer() {
  return <footer className="bg-olive text-ivory py-20 px-6 text-center" data-id="element-31">
      <div className="max-w-2xl mx-auto flex flex-col items-center" data-id="element-32">
        <GuitarCrossMark color="#FBF8F0" className="h-10 w-10 mb-6 opacity-90" data-id="element-33" />

        <div className="flex items-center justify-center gap-4 w-full max-w-xs mx-auto mb-8" data-id="element-34">
          <div className="h-px bg-gold/40 flex-1" data-id="element-35"></div>
          <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg" className="text-gold" data-id="element-36">
            <path d="M8 13.5L6.84 12.44C2.72 8.7 0 6.24 0 3.24C0 1.04 1.74 -0.7 3.94 -0.7C5.18 -0.7 6.36 -0.12 7.14 0.78L8 1.76L8.86 0.78C9.64 -0.12 10.82 -0.7 12.06 -0.7C14.26 -0.7 16 1.04 16 3.24C16 6.24 13.28 8.7 9.16 12.45L8 13.5Z" fill="currentColor" fillOpacity="0.25" stroke="currentColor" strokeWidth="1" data-id="element-37" />
          </svg>
          <div className="h-px bg-gold/40 flex-1" data-id="element-38"></div>
        </div>

        <h3 className="text-3xl font-serif text-ivory mb-3" data-id="element-39">Družina Siter</h3>
        <p className="font-sans text-sm text-ivory/70 italic" data-id="element-40">
          Veselimo se skupnega praznovanja.
        </p>
      </div>
    </footer>;
}